import React, { Component } from 'react'
import './home.css'
import NavArr from '../handf/nav.json'
import Footer from '../handf/Footer'
import PopUp from '../round/PopUp'

class YJ extends Component {
  constructor(props) {
    super(props)
    this.state = {
      YJPage: 0,
    }
  }
  componentDidMount = function () {
    let Route = this.props.location.search
    let ThreeIndex = Route.lastIndexOf('?') //'_'最后出现的位置
    if (ThreeIndex === -1) {
      this.setState({
        YJPage: 0,
      })
    } else {
      let sb = Route.substring(ThreeIndex + 1)
      this.setState({
        YJPage: Number(sb),
      })
    }

    window.onscroll = function () {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      let AllHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight
      // console.log("滚动距离" + scrollTop);
      // console.log(AllHeight - scrollTop);
      // 计算滚动条长度的函数
      let sb = document.querySelector('.YJBackTop')
      if (sb) {
        if (scrollTop > 450) {
          document.querySelector('.YJBackTop').style.display = 'block'
        } else {
          document.querySelector('.YJBackTop').style.display = 'none'
        }
        if (AllHeight - scrollTop > 500) {
          document.querySelector('.YJBackTop').style.position = 'fixed'
          document.querySelector('.YJBackTop').style.bottom = '100px'
        } else {
          document.querySelector('.YJBackTop').style.position = 'absolute'
          document.querySelector('.YJBackTop').style.bottom = '600px'
        }
      }
    }
  }

  componentWillUnmount = () => {
    this.setState = (state, callback) => {}
  }

  NavListClick = (item, index) => {
    const { history } = this.props
    history.push(item.router)
    this.setState({
      YJPage: 0,
    })
  }

  YJOne() {
    const { history } = this.props
    history.push('./yj?1')
    this.setState({
      YJPage: 1,
    })
  }

  YJTwo() {
    const { history } = this.props
    history.push('/yj?2')
    this.setState({
      YJPage: 2,
    })
  }

  BackTop = () => {
    window.scrollTo({
      left: 0,
      top: 0,
      behavior: 'smooth',
    })
  }

  //提示弹窗
  ChildBackTip = (event) => {
    if (event === 'CrossOut') {
      this.setState({
        PopUp: '',
      })
    }
  }

  render() {
    return (
      <div className={'Home'}>
        {/*背景*/}
        <div className={'YJTopBgHeight'}>
          <div className={'YJBg'}>
            {/*菜单*/}
            <div className={'HomeNavTopBox'} style={{ position: 'relative' }}>
              <div className={'NavTopBox'}>
                <div className={'HomeLogoBox'}>
                  <img
                    className={'HomeLogo'}
                    src="http://oss.asfcyy.com/richTextImage/616aeb76dee911ee9dc800163e3521a2.png"
                    alt=""
                  />
                </div>
                <div className={'NavTop clearfix'}>
                  {NavArr.map((item, index) => (
                    <div
                      className={'NavTopList'}
                      key={index}
                      onClick={() => this.NavListClick(item, index)}
                    >
                      {item.name}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className={'BgTu'}>
              <img
                style={{ top: -200 }}
                className={'BgTuImg'}
                src="http://oss.asfcyy.com/richTextImage/803d42a8e17e11f09dcd00163e3521a2.jpg"
                alt=""
              />
            </div>
          </div>
        </div>

        <div className={'YJMNFXBox'} style={{ marginTop: 32 }}>
          <div className={'GSZXTit'} style={{ marginBottom: 1 }}>
            赛事愿景
          </div>
          <div className={'GSZXBor'} style={{ marginBottom: 50 }}>
            {' '}
          </div>
        </div>
        {/*愿景简略*/}
        {this.state.YJPage === 0 && (
          <div>
            <div className={'YJMNFXBox'} style={{ marginBottom: 60 }}>
              <div
                className={'YJMNFXTit'}
                style={{ marginTop: 10, textAlign: 'center' }}
              >
                以体聚情 以飞促学
              </div>
              <div className={'YJMNFXTit'} style={{ textAlign: 'center' }}>
                模拟飞行在中国
              </div>
              <div
                className={'YJMNFXTit'}
                style={{ marginBottom: 28, fontSize: 17, textAlign: 'center' }}
              >
                ——深入贯彻“体育是教育重要组成、教育是体育主要功能”的体教融合理念
              </div>
              <div className={'YJMNFXMain'}>
                航空，是一个包罗了装备制造、航线运输、空天军事、低空运动等等多个领域的博大体系。1909年9月21日，冯如先生驾驶中国自主研制的第一架有动力的航空器飞上蓝天，实现了中国航空事业的起点。2016年8月，习总书记在中国航发成立大会上做出重要批示：为把我国建成航空强国而不懈奋斗。强国须强航空，强航空则须强少年！在党中央国务院的关心下，航空人才的培育日益成为各级各界共同关注、支持、研究、推动的焦点，青少年的航空基础教育越来越成为关乎中华民族伟大复兴的大国利器！
              </div>
              <div className={'YJMNFXMain'}>
                与此同时，我国的基础教育正在发生重大变化，随着第八次基础教育课程改革，基础教育的内容向培养核心素养转变。航空百年的知识底蕴，涵盖着基础教育多方面的内容，如：科学、探究、艺术、文化、历史、国防爱国主义等等，担当学生核心素养教育的载体和目标成为社会共识。
              </div>
              <div
                style={{ width: '100%', height: 38, margin: '16px 0' }}
                onClick={this.YJOne.bind(this)}
              >
                <div className={'YJBtn'}>
                  <div className={'YJBtnIco2'}> </div>
                  <div
                    className={'YJBtnBor'}
                    style={{ backgroundColor: '#00479D' }}
                  >
                    {' '}
                  </div>
                  <div className={'YJBtnWord'} style={{ color: '#00479D' }}>
                    查看更多
                  </div>
                </div>
              </div>
            </div>
            <div className={'YJMNFXBox'} style={{ marginBottom: 60 }}>
              <div
                className={'YJMNFXTit'}
                style={{ marginTop: 60, marginBottom: 28, textAlign: 'center' }}
              >
                全国青少年模拟飞行锦标赛时间年表
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>2005年</span>
                模拟飞行运动在国家体育总局正式立项开展。
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>
                  第一届2007年7月27-29日
                </span>
                在在南京市全民健身中心举办，由南京市航空运动协会、南京市龙江体育馆承办。这是模拟飞行赛事的起步，共有来自河南、南京、深圳、北京、青岛等七省市的9支代表队56名选手参与了首战。本次赛场设置在南京闹市区新街口附近的南京全面健身中心一楼大厅内。比赛大屏幕正对大门口，是前来健身休闲的人流的必经之地。为方便观众体验，还在大厅西侧摆放了多台装备了模拟设备的电脑供练习体验。据估计，两天赛事的围观观众及体验者有一万多人。中国香港派队参加了本届比赛。
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>
                  第二届2008年10月13日－17日
                </span>
                在河南郑州举办。由郑州市教育局、河南省航协承办，郑州市回民中学和河南蓝翔青少年航空模型俱乐部协办。来自全国12个省、区、市的162名选手参加了四个项目四个组别的竞逐。赛事得到了郑州市政府、郑州市教育局的高度重视。不但拨备专门的竞赛经费，还组成两套筹备的班子，召开6次筹备及协调会，保障了大会的顺利圆满和成功。
              </div>
              <div
                style={{ width: '100%', height: 38, margin: '16px 0' }}
                onClick={this.YJTwo.bind(this)}
              >
                <div className={'YJBtn'}>
                  <div className={'YJBtnIco2'}> </div>
                  <div
                    className={'YJBtnBor'}
                    style={{ backgroundColor: '#00479D' }}
                  >
                    {' '}
                  </div>
                  <div className={'YJBtnWord'} style={{ color: '#00479D' }}>
                    查看更多
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/*愿景详情*/}
        {this.state.YJPage === 1 && (
          <div>
            <div className={'YJMNFXBox'} style={{ marginBottom: 60 }}>
              <div
                className={'YJMNFXTit'}
                style={{ marginTop: 60, textAlign: 'center' }}
              >
                以体聚情 以飞促学
              </div>
              <div className={'YJMNFXTit'} style={{ textAlign: 'center' }}>
                模拟飞行在中国
              </div>
              <div
                className={'YJMNFXTit'}
                style={{ marginBottom: 28, fontSize: 17, textAlign: 'center' }}
              >
                ——深入贯彻“体育是教育重要组成、教育是体育主要功能”的体教融合理念
              </div>
              <div className={'YJMNFXMain'}>
                航空，是一个包罗了装备制造、航线运输、空天军事、低空运动等等多个领域的博大体系。1909年9月21日，冯如先生驾驶中国自主研制的第一架有动力的航空器飞上蓝天，实现了中国航空事业的起点。2016年8月，习总书记在中国航发成立大会上做出重要批示：为把我国建成航空强国而不懈奋斗。强国须强航空，强航空则须强少年！在党中央国务院的关心下，航空人才的培育日益成为各级各界共同关注、支持、研究、推动的焦点，青少年的航空基础教育越来越成为关乎中华民族伟大复兴的大国利器！
              </div>
              <div className={'YJMNFXMain'}>
                与此同时，我国的基础教育正在发生重大变化，随着第八次基础教育课程改革，基础教育的内容向培养核心素养转变。航空百年的知识底蕴，涵盖着基础教育多方面的内容，如：科学、探究、艺术、文化、历史、国防爱国主义等等，担当学生核心素养教育的载体和目标成为社会共识。
              </div>
              <div className={'YJMNFXMain'}>
                模拟飞行运动是国家体育总局在2005年正式立项的航空体育项目。国家体育总局航空无线电模型运动管理中心、中国航空运动协会模拟飞行委员会负责模拟飞行运动的全国行业管理。17年来，中心和协会面对所有人群，尤其在青少年基础教育领域主动作为，团结、服务、引领相关单位共筑面向全体青少年的公共服务体系，在教练员、辅导员培训；学生心理、体能、航空素养等多元化能力提升；开展各级各类竞赛，开拓创新、深耕细作，着力打造并以全国青少年模拟飞行锦标赛这一品牌赛事为核心，形成从全国到地方层层传导的组织体系，打造了一支专业、实干的教练员、裁判员和教师团队，形成全社会统一目标、系统谋划、整合资源、强化内涵的青少年航空体育健康促进、组织服务、竞赛活动和文化教育体系。通过贴合当前国家政策和社会需求发布和不断修订《全国模拟飞行运动管理办法》，使项目显现出越来越开放的平台发展趋势。以飞行这一独具穿透力、生命力和传导力的特征引领青少年学生励志奋进，提供全公益、均等化、层次性、高质量的服务。
              </div>
              <div className={'YJMNFXMain'}>
                随着数字化技术的全面深化，模拟飞行运动全面实现了远程全自动评判技术，做到了线上办赛、线上沉浸式自主学习、大数据管理分析等技术的突破，能够根据各种形势变化，打破时间空间限制，做到线上线下办赛的有机结合和灵活转换。基于数字化技术的模拟飞行运动，随着时代的进步会越来越有条件带动更多的学校、家庭去实现沉浸式飞行情境体验，形成家长志愿学习、学校开放融入、社会有序组织、市场多元供给的格局，最终推动我国航空人口数量和质量得到提升，航空意识增强，为建设新时代航空强国贡献绵薄之力。
              </div>
              <div className={'YJLink'}>
                <span onClick={this.YJTwo.bind(this)}>
                  下一篇：全国青少赛模拟飞行锦标赛时间年表
                </span>
              </div>
            </div>
          </div>
        )}
        {this.state.YJPage === 2 && (
          <div>
            <div className={'YJMNFXBox'} style={{ marginBottom: 60 }}>
              <div
                className={'YJMNFXTit'}
                style={{ marginTop: 60, marginBottom: 28, textAlign: 'center' }}
              >
                全国青少年模拟飞行锦标赛时间年表
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>2005年</span>
                模拟飞行运动在国家体育总局正式立项开展。
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>
                  第一届2007年7月27-29日
                </span>
                在在南京市全民健身中心举办，由南京市航空运动协会、南京市龙江体育馆承办。这是模拟飞行赛事的起步，共有来自河南、南京、深圳、北京、青岛等七省市的9支代表队56名选手参与了首战。本次赛场设置在南京闹市区新街口附近的南京全面健身中心一楼大厅内。比赛大屏幕正对大门口，是前来健身休闲的人流的必经之地。为方便观众体验，还在大厅西侧摆放了多台装备了模拟设备的电脑供练习体验。据估计，两天赛事的围观观众及体验者有一万多人。中国香港派队参加了本届比赛。
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>
                  第二届2008年10月13日－17日
                </span>
                在河南郑州举办。由郑州市教育局、河南省航协承办，郑州市回民中学和河南蓝翔青少年航空模型俱乐部协办。来自全国12个省、区、市的162名选手参加了四个项目四个组别的竞逐。赛事得到了郑州市政府、郑州市教育局的高度重视。不但拨备专门的竞赛经费，还组成两套筹备的班子，召开6次筹备及协调会，保障了大会的顺利圆满和成功。
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>
                  第三届2009年12月5日—6日
                </span>
                在南京举办，全国32支代表队的213名运动员参加了这次比赛。
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>
                  第四届2010年9月25日-29日
                </span>{' '}
                在山东莱芜举办国际航空体育节期间，于莱芜市电脑大厦举行。
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>
                  第五届2011年11月12日-14日
                </span>
                在南京中华中学附属小学举行。共有来自全国12个省、区、市的42支代表队230名选手参加了15个项目的比赛。
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>
                  第六届2012年11月16日—19日
                </span>{' '}
                在南京市后标营小学举行，来自全国的68支代表队共385名选手参加了比赛。
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>第七届2014年</span>
                全国青少年模拟飞行锦标赛于7月19日至21日在北京市第五十七中学举办。来自北京、广东、广西、河北、河南、江苏、南京、深圳、四川、天津、新疆、浙江12个省区市的32所学校、178名学生参加本次比赛。
                19日的开幕式主题为中国航协模拟飞行十年。
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>
                  第八届2015年10月24日－10月25日
                </span>
                “双齐杯”2015年全国青少年模拟飞行锦标赛在江苏南京举办。比赛由中国航空运动协会主办，由南京市建邺区教育局和南京市中华中学附属小学承办。来自北京、江苏、四川、安徽、广东、新疆等地的165名中小学生参加了本次比赛。比赛获得了双齐国际贸易（上海）有限公司的冠名赞助。
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>
                  第九届2016年11月26-27日
                </span>
                全国青少年模拟飞行锦标赛在北京市八一学校举办。比赛由中国航空运动协会主办，由北京市八一学校承办。来自北京、河北、山东、江苏、安徽、广东、河南等地的近300名中小学生参加了本次比赛。竞赛首次将开幕式设计成一次以承办学校命名航班号的航线飞行，首次进行特技飞行表演，首次引入VR体验设备，加深了观众和参赛者对模拟飞行的认知和体会，以“新飞行，新剧情”的主题引发了模拟飞行与青少年参与者的情感共鸣，加强了文化建设，取得了很好的效果。
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>
                  第十届2017年12月2日-4日
                </span>{' '}
                由国家体育总局航管中心主办的2017全国青少年模拟飞行锦标赛在黑龙江省科技馆举办。由全国十二个省市精选出的的三十五支代表队近300名爱好模拟飞行的青少年展开了飞行角逐。这次比赛设置了六个飞行科目，涉及到的有民用飞机、战斗机，还有特技类飞机等项目，其中的本场五边争霸赛，更是临场增加了侧风，考验着小飞行员的飞行技术。比赛首次设置了“中国航协金牌飞行少年”奖项，奖励基础飞行科目的冠军选手。来自南京市浦口新城实验小学的杨玲玲以决赛90.89分的成绩获得了本场五边争霸赛科目不分组别最好成绩，被授予“中国航协金牌飞行少年”称号。本次比赛获得六个科目三个组别前三名的共54名选手，还在莱特兄弟体验馆的仿真模拟机上，展开了飞行角逐，在更加真实的飞行训练环境里挑战技术难度。承办单位提供了全免费公益化模拟舱体验。
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>
                  第十一届2018年11月22-25日
                </span>
                由国家体育总局航管中心、中国航空运动协会、黑龙江省体育局、黑龙江省教育厅、黑龙江省科技厅共同主办的2018年全国青少年模拟飞行锦标赛在哈尔滨市举行。选拔自12个省市的46支参赛队共411人参与了本届比赛，赛事同期举办“天空很辽阔
                我们一起飞”全国模拟飞行互动体验嘉年华活动，在黑龙江省体育局、教育厅、科技厅的联合发文动员之下，全省各地共700名中小学生参与了嘉年华活动，来自北京、江苏等地的教育界代表与黑龙江省中小学校长共同参与“模拟飞行与青少年科技素质培养”主题教育研讨会。本届赛事活动总人数突破一千人，成为本赛事历史上规模最大的一届比赛。
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>
                  第十二届2019年11月24-26日
                </span>
                全国青少年模拟飞行锦标赛在上海市梅赛德斯奔驰中心音乐厅举办。本届锦标赛通过层层选拔，来自黑龙江、河北、山东、山西、新疆、河南、安徽、江苏、浙江、贵州、广东、上海等14个省市、33所中小学校的51支代表队510名选手进阶决赛。角逐包括竞速、复杂气象、发动机失效、航母着舰、航空解说、单机格斗等多个任务、复杂条件下的处理技巧，展现飞行天赋、航空知识积淀、航空情怀和飞行意志品质。
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>2020年6月1日-10月7日</span>
                因疫情转而在互联网举办，六月一日开赛以来，经过四个月、来自29省市的61219人次的激烈鏖战，圆满顺利地完成了包括军航和民航两大类共13个竞赛科目的赛程。模拟飞行服务平台官网根据竞赛规程公布了各月排行榜，经过公示，1300余人次获得等次奖。其中，解说口才项目评比获得了来自全社会11万人的参与；各项目的参赛选手技术水平较以往各年度呈上升趋势，刷新多项全国最好成绩；竞赛同期举办的首届虚拟特技飞行表演节与模拟飞行课程直播吸引了超过230万点击量和热度。
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>
                  第十三届2021年-2022年
                </span>
                全国青少年模拟飞行锦标赛列入教育部面向中小学生允许举办的竞赛活动名单，自2021年起在全国各地开展培训服务和省市选拔赛，2022年7月22日-24日于湖北.武汉举办总决赛。
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>
                  第十四届2023年7月31日-8月4日
                </span>
                第十四届全国青少年模拟飞行锦标赛，自2023年3月起在全国各地开展培训服务和省市选拔赛，于内蒙古呼伦贝尔市举办总决赛。
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>
                  第十五届2024年7月25日-7月28日
                </span>
                第十五届全国青少年模拟飞行锦标赛于海南省琼海市博鳌镇亚洲论坛国际会议中心举办总决赛。本次参赛成员遍布全国各地，包括了27个省、自治区、直辖市的263支顶级团队，参赛人数超过3000人。
              </div>
              <div className={'YJMNFXMain'}>
                <span style={{ fontWeight: 'bold' }}>
                  第十六届2025年8月5日-8月9日
                </span>
                第十六届全国青少年模拟飞行锦标赛总决赛于陕西省榆林市举办。总决赛吸引了来自全国27个省、自治区、直辖市的270支队伍，超5000名运动员、教练员、领队和随行人员齐聚美丽的塞上城市。本届赛事在竞赛之余举办公益大师课，来自我国知名航空飞行高校：北京航空航天大学飞行学院、南京航空航天大学通航与飞行学院和中国民航飞行学院的专家为青少年在民用航空领域的升学和自我提升传授知识，还有我国歼20首飞试飞员为青少年在军事航空方面打开视野。
              </div>
              <div className={'YJLink'}>
                <span onClick={this.YJOne.bind(this)}>
                  上一篇：以体聚情以"飞"促学模拟飞行在中国
                </span>
              </div>
            </div>
          </div>
        )}
        {this.state.YJPage !== 0 && (
          <div
            className={'YJBackTop'}
            style={{ display: 'none' }}
            onClick={this.BackTop.bind(this)}
          >
            <div className={'YJBackTopIco'}> </div>
            <div className={'YJBackTopW'}>飞到顶部</div>
          </div>
        )}

        <Footer />
        {this.state.PopUp === '提示弹窗' && (
          <PopUp
            ChildBackClick={this.ChildBackTip.bind(this)}
            type={'提示'}
            message={this.state.MessageTip}
            OutButton={'Yes'}
          />
        )}
      </div>
    )
  }
}

export default YJ
